"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/slicedToArray");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _Banner = _interopRequireWildcard(require("../Banner"));

var _Button = _interopRequireDefault(require("../Button"));

var _LivePlayer = require("./LivePlayer.style");

function SlidoEmbed(_ref) {
  var banner = _ref.banner,
      buttonType = _ref.buttonType,
      label = _ref.label,
      url = _ref.url,
      user = _ref.user;

  var _ref2 = (0, _react.useState)(false),
      _ref3 = _slicedToArray(_ref2, 2),
      showEmbed = _ref3[0],
      setShowEmbed = _ref3[1];

  var _ref4 = (0, _emotionTheming.useTheme)(),
      space = _ref4.space;

  var loggedIn = user && user.loggedIn;
  var queryParams = user ? "?user_name=".concat(encodeURIComponent(user.firstName), "&user_email=").concat(encodeURIComponent(user.email), "&user_company=").concat(encodeURIComponent(user.company)) : '';
  var fullUrl = loggedIn ? "".concat(url, "/").concat(queryParams) : url;

  var bannerProps = _objectSpread(_objectSpread({}, banner), {}, {
    mt: space.large,
    textColor: 'light',
    size: 'large'
  });

  function handleClick(e) {
    e.preventDefault();
    setShowEmbed(true);
  }

  return /*#__PURE__*/_react.default.createElement(_LivePlayer.InteractionTool, null, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, showEmbed ? /*#__PURE__*/_react.default.createElement("iframe", {
    title: "Slido",
    src: fullUrl,
    height: "100%",
    width: "100%",
    frameBorder: "0"
  }) : /*#__PURE__*/_react.default.createElement(_LivePlayer.InteractionOverlay, null, /*#__PURE__*/_react.default.createElement(_Banner.default, bannerProps), /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: buttonType,
    onClick: handleClick
  }, label))));
}

SlidoEmbed.propTypes = {
  banner: _propTypes.default.shape(_Banner.bannerPropTypes),
  buttonType: _propTypes.default.string,
  label: _propTypes.default.string,
  user: _propTypes.default.shape({
    email: _propTypes.default.string,
    firstName: _propTypes.default.string,
    company: _propTypes.default.string,
    loggedIn: _propTypes.default.bool
  }),
  url: _propTypes.default.string.isRequired
};
SlidoEmbed.defaultProps = {
  banner: null,
  buttonType: 'secondary',
  label: 'Join the discussion',
  user: null
};
var _default = SlidoEmbed;
exports.default = _default;